import React, { Component } from "react";
import { FileUploader } from "react-drag-drop-files";
import { Add1Icon, CloudIcon, EditIcon } from "../../assets/icons";
import SelectTagsModal from "../addNewTalentModals/SelectTagsModal";
import { FaPencilAlt, FaTimes, FaTrash } from "react-icons/fa";
import { observer } from "mobx-react";
import voiceStore from "../../stores/voiceStore";
import { PiWarningCircleFill } from "react-icons/pi";

const fileTypes = ["mp3", "wav", "mp4", "ogg", "webm"];
const maxFileSize = 100;

const UpdateTalentVoicesModal = observer(
  class UpdateTalentVoicesModal extends Component {
    constructor(props) {
      super(props);
      this.state = {
        files: [],
        fileUploadError: "",
        editingIndex: null,
        newName: "",
        showModal: false,
        currentFileIndex: null,
        videoModalVisible: false,
        videoModalFile: null,
        showDeleteModal: false,
        deleteSampleId: null,
        loading: false
      };
    }
    // Handle Single File Upload
    // handleChange = (file) => {
    //     this.setState({ fileUploadError: null })
    //     if (file.size <= maxFileSize * 1024 * 1024) {
    //         const newFile = {
    //             fileName: `${file.name.split('.')[0]}${this.state.files.length + 1}`,
    //             fileType: file.type,
    //             voiceFile: file,
    //             tags: {
    //                 gender: null,
    //                 languages: [],
    //                 accents: [],
    //                 styles: [],
    //                 ageGroups: [],
    //                 additionalTags: []
    //             },
    //         };
    //         this.setState(prevState => ({
    //             files: [...prevState.files, newFile],
    //             fileUploadError: ''
    //         }));
    //     } else {
    //         alert('File size cannot exceed 10MB.');
    //     }
    // };

    handleChange = (files) => {
      this.setState({ fileUploadError: null });

      const validFiles = Array.from(files).filter(
        (file) => file.size <= maxFileSize * 1024 * 1024
      );

      if (validFiles.length !== files.length) {
        alert("Some files exceed the maximum size of 10MB and were not added.");
      }

      const newFiles = validFiles.map((file, index) => ({
        fileName: `${file.name.split(".")[0]}_${
          this.state.files.length + index + 1
        }`,
        fileType: file.type,
        voiceFile: file,
        tags: {
          gender: null,
          languages: [],
          accents: [],
          styles: [],
          ageGroups: [],
          additionalTags: [],
        },
      }));

      this.setState((prevState) => ({
        files: [...prevState.files, ...newFiles],
        fileUploadError: "",
      }));
    };

    handleEdit = (index) => {
      this.setState({
        editingIndex: index,
        newName: this.state.files[index].fileName,
      });
    };

    handleNameChange = (event) => {
      this.setState({ newName: event.target.value });
    };

    handleSave = () => {
      const { files, editingIndex, newName } = this.state;
      files[editingIndex].fileName = newName;
      this.setState({
        files,
        editingIndex: null,
        newName: "",
      });
    };

    handleAddTags = (index) => {
      this.setState({ showModal: true, currentFileIndex: index });
    };
    handleAddBulkTags = () => {
      this.setState({ showModal: true, currentFileIndex: null });
    };
    handleSaveTags = (tags) => {
      const { files, currentFileIndex } = this.state;

      if (currentFileIndex === null) 
      {
         
        voiceStore
          .updateTalentVoiceTags(
            {
              tags
            }
          )
          .then(() => {
            this.setState((prevState) => {
                const updatedFiles = [];
                for(var i=0; i<prevState.files.length; i++)
                {
                  const fileToUpdate = files[i];
                  const updatedFile = { ...fileToUpdate, tags };
                  updatedFiles.push(updatedFile)
                }
                return { files: updatedFiles, showModal: false };

                
            });
          })
          .catch((error) => {
            console.error("Error updating tags:", error);
          });
        
      }else
      {

        const fileToUpdate = files[currentFileIndex];

        const updatedFile = { ...fileToUpdate, tags };

        if (fileToUpdate.exist) {
          // Update existing file tags in the store
          voiceStore
            .updateTalentVoiceTags(updatedFile)
            .then(() => {
              this.setState((prevState) => {
                const updatedFiles = prevState.files.map((file, index) =>
                  index === currentFileIndex ? updatedFile : file
                );
                return { files: updatedFiles, showModal: false };
              });
            })
            .catch((error) => {
              console.error("Error updating tags:", error);
            });
        } else {
          // Update new file tags locally
          this.setState((prevState) => {
            const updatedFiles = prevState.files.map((file, index) =>
              index === currentFileIndex ? updatedFile : file
            );
            return { files: updatedFiles, showModal: false };
          });
        }
      }
    };

    transformData = (data) => {
      const keyMap = {
        gender: "gender",
        language: "languages",
        accent: "accents",
        style: "styles",
        age: "ageGroups",
        additional_tags: "additionalTags",
      };

      const newData = {};

      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          const value = data[key];

          if (keyMap[key]) {
            const newKey = keyMap[key];

            if (!value || value.length === 0) {
              newData[newKey] = [];
              continue;
            }

            if (Array.isArray(value) && typeof value[0] === "string") {
              newData[newKey] = value.flatMap((val) => {
                if (val.includes(",")) {
                  return val.split(",").map((part) => ({
                    value: part.trim(),
                    label: part.trim(),
                  }));
                }
                return [
                  {
                    value: val.trim(),
                    label: val.trim(),
                  },
                ];
              });
            } else {
              newData[newKey] = value
                .filter((val) => val !== "")
                .map((val) => ({
                  value: val,
                  label: val,
                }));
            }
          }
        }
      }

      return newData;
    };

    componentDidMount() {
      voiceStore.talent.voice_data.map((file) => {
        file.exist = true;
        const newData = this.transformData(file.tags);
        file.tags = newData;
        return file;
      });
      this.setState({ files: voiceStore.talent.voice_data });

      document.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }

    handleKeyDown = (event) => {
      if (event.key === "Escape") {
        voiceStore.setUpdateTalentVoicesModalVisible(false);
      }
    };

    toggleDeleteModal = (deleteSampleId = null) => {
      this.setState({
        showDeleteModal: !this.state.showDeleteModal,
        deleteSampleId: deleteSampleId,
      });
    };

    handleDelete = () => {
      const { deleteSampleId } = this.state;
      if (deleteSampleId) {
        voiceStore
          .deleteSample(deleteSampleId)
          .then(() => {
            if (this.state.files.length > 0) {
              let files = this.state.files.filter(
                (item) => item.sample_id !== deleteSampleId
              );
              this.setState({ files: files });
            }
            this.setState({ showDeleteModal: false, deleteSampleId: null });
          })
          .catch((error) => {
            console.error(error);
          });
      }
    };

    renderTags = (tags) => {
      return (
        tags &&
        tags
          .filter((tag) => tag && tag.trim() !== "")
          .join(",")
          .split(",")
          .map((tag) => tag.trim())
          .filter((tag) => tag !== "")
          .map((tag) => (
            <span
              key={tag}
              className="font-normal text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md px-4"
            >
              {tag}
            </span>
          ))
      );
    };

    renderExistingVoices = (file, index) => {
      return (
        <tr
          key={index}
          className="border-b border-[#DDE1E6] flex flex-1 justify-center flex-row"
        >
          <td className="p-4 flex flex-1 items-center justify-between">
            <div className="flex items-center justify-center ">
              <span className="font-normal text-xs text-[#21272A]">
                {file.fileName}
              </span>
            </div>
          </td>

          <td className="text-center flex flex-1 justify-center items-center">
            {file?.fileType.includes("mp4") ? (
              <button
                onClick={() => {
                  voiceStore.setVideoModal({
                    fileName: file.fileName,
                    video:
                      process.env.REACT_APP_BASE_URL + "/" + file.voice_path,
                  });
                }}
                className="text-blue-500 underline underline-offset-2"
              >
                show video
              </button>
            ) : (
              <audio
                className="w-[140px] lg:w-[300px]"
                controls
                controlsList="nodownload noplaybackrate"
              >
                <source
                  src={process.env.REACT_APP_BASE_URL + "/" + file.voice_path}
                />
                Your browser does not support the audio element.
              </audio>
            )}
          </td>

          <td className="p-4 flex flex-1 flex-row flex-wrap justify-between items-center">
            <div className="flex flex-1 flex-wrap gap-2">
              {file.tags.gender?.value ? (
                <span
                  key={file.tags.gender.value}
                  className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                >
                  {file.tags.gender.label}
                </span>
              ) : (
                file.tags.gender.map(
                  (tag) =>
                    tag.value && (
                      <span
                        key={tag.value}
                        className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                      >
                        {tag.label}
                      </span>
                    )
                )
              )}
              {file.tags.languages.map(
                (tag) =>
                  tag.value && (
                    <span
                      key={tag.value}
                      className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                    >
                      {tag.label}
                    </span>
                  )
              )}
              {file.tags.accents.map(
                (tag) =>
                  tag.value && (
                    <span
                      key={tag.value}
                      className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                    >
                      {tag.label}
                    </span>
                  )
              )}
              {file.tags.ageGroups.map(
                (tag) =>
                  tag.value && (
                    <span
                      key={tag.value}
                      className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                    >
                      {tag.label}
                    </span>
                  )
              )}
              {file.tags.styles.map(
                (tag) =>
                  tag.value && (
                    <span
                      key={tag.value}
                      className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                    >
                      {tag.label}
                    </span>
                  )
              )}
              {file.tags.additionalTags.map(
                (tag) =>
                  tag.value && (
                    <span
                      key={tag.value}
                      className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                    >
                      {tag.label}
                    </span>
                  )
              )}
            </div>

            <button
              className="flex items-center"
              onClick={() => this.handleAddTags(index)}
            >
              <FaPencilAlt size={15} />
            </button>
            <button
              className="flex items-center ml-4"
              onClick={() => this.toggleDeleteModal(file.sample_id)}
            >
              <FaTrash size={15} color="red"></FaTrash>
            </button>
          </td>
        </tr>
      );
    };

    renderNewVoices = (file, index) => {
      const { editingIndex, newName } = this.state;

      return (
        <tr
          key={index}
          className="border-b border-[#DDE1E6] flex flex-1 justify-center flex-row"
        >
          <td className="p-4 flex flex-1 items-center justify-between">
            {editingIndex === index ? (
              <input
                type="text"
                value={newName}
                onChange={this.handleNameChange}
                onBlur={this.handleSave}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this.handleSave();
                  }
                }}
                autoFocus
                className="flex-1"
              />
            ) : (
              <div className="flex items-center">
                <span className="font-normal text-xs text-[#21272A]">
                  {file.fileName}
                </span>
                <img
                  className="w-4 cursor-pointer ml-2"
                  src={EditIcon}
                  alt="Edit"
                  onClick={() => this.handleEdit(index)}
                />
              </div>
            )}
          </td>

          <td className="text-center flex flex-1 justify-center items-center ">
            {file?.fileType.includes("audio") ? (
              <audio
                className="w-[140px] lg:w-[300px]"
                controls
                controlsList="nodownload noplaybackrate"
              >
                <source src={URL.createObjectURL(file.voiceFile)} />
                Your browser does not support the audio element.
              </audio>
            ) : (
              <button
                onClick={() => {
                  voiceStore.setVideoModal({
                    fileName: file.fileName,
                    video: URL.createObjectURL(file.voiceFile),
                  });
                }}
                className="text-blue-500 underline underline-offset-2"
              >
                show video
              </button>
            )}
          </td>

          <td className="p-4 flex flex-1 flex-wrap justify-between items-center ">
            <div className="flex flex-1 flex-wrap gap-2">
              {file.tags.gender?.value && (
                <span
                  key={file.tags.gender.value}
                  className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                >
                  {file.tags.gender.label}
                </span>
              )}
              {file.tags.languages.map((tag) => (
                <span
                  key={tag.value}
                  className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                >
                  {tag.label}
                </span>
              ))}
              {file.tags.accents.map((tag) => (
                <span
                  key={tag.value}
                  className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                >
                  {tag.label}
                </span>
              ))}
              {file.tags.ageGroups.map((tag) => (
                <span
                  key={tag.value}
                  className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                >
                  {tag.label}
                </span>
              ))}
              {file.tags.styles.map((tag) => (
                <span
                  key={tag.value}
                  className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                >
                  {tag.label}
                </span>
              ))}
              {file.tags.additionalTags.map((tag) => (
                <span
                  key={tag.value}
                  className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                >
                  {tag.label}
                </span>
              ))}
            </div>
            <button
              className="flex items-center"
              onClick={() => this.handleAddTags(index)}
            >
              <img className="w-3" src={Add1Icon} alt="Add" />
            </button>
          </td>
        </tr>
      );
    };

    render() {
      const { files, showModal, currentFileIndex, loading } = this.state;

      return (
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 z-[52]">
          <div className="flex relative flex-col overflow-scroll w-full lg:w-[85%] h-full lg:h-[85%]  py-6 px-5 lg:px-10 overflow-y-scroll overflow-x-hidden bg-white shadow-lg">
            <div className="flex flex-1 flex-col">
              <div className="flex flex-col mb-6">
                <span className="font-normal text-base lg:text-lg text-[#21272A] my-6">
                  Add voice sample
                </span>
                <FileUploader
                  handleChange={this.handleChange}
                  name="file"
                  types={fileTypes}
                  maxSize={maxFileSize}
                  multiple
                  uploadedLabel="Uploaded Successfully!"
                  onTypeError={(err) => {
                    this.setState({ fileUploadError: err });
                  }}
                  children={
                    <div className="flex flex-col bg-[#F2F4F8] py-3 lg:py-0 items-center">
                      <img
                        className="w-11 lg:w-12"
                        src={CloudIcon}
                        alt="Cloud"
                      />
                      <span className="font-medium text-xs lg:text-sm text-[#292D32] hidden lg:flex">
                        Choose a file or drag & drop it here
                      </span>
                      <span className="font-medium text-xs lg:text-sm text-[#292D32] flex lg:hidden">
                        Choose a file
                      </span>

                      <span className="font-medium text-xs lg:text-sm text-[#A9ACB4] text-center">{`${fileTypes.map(
                        (type) => type
                      )} format only, up to ${maxFileSize}MB`}</span>

                      <span className="text-red-600 animate-pulse mt-3">
                        {this.state.fileUploadError}
                      </span>
                    </div>
                  }
                />
              </div>

              <div>
                {files.length > 0 && (
                  <table className="flex flex-col flex-1 shrink-0 w-full bg-transparent border text-center border-[#DDE1E6]">
                    <thead>
                      <tr className="bg-[#E8E9ED] flex flex-1 justify-between">
                        <th className="font-normal text-xs lg:text-sm text-[#121619] p-3">
                          Name
                        </th>
                        <th className="font-normal text-xs lg:text-sm text-[#121619] p-3 ">
                          Voice Samples
                        </th>
                        <th className="font-normal text-xs lg:text-sm text-[#121619] p-3">
                          Tags
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {files.map((file, index) => {
                        if (file.exist) {
                          return this.renderExistingVoices(file, index);
                        } else {
                          return this.renderNewVoices(file, index);
                        }
                      })}
                    </tbody>
                  </table>
                )}
              </div>

              {showModal && (
                <SelectTagsModal
                  onSave={this.handleSaveTags}
                  onClose={() => {
                    this.setState({ showModal: false, currentFileIndex: null });
                  }}
                  selectedTags={
                    currentFileIndex !== null
                      ? files[currentFileIndex].tags
                      : {}
                  }
                />
              )}

              <button
                onClick={() => {
                  voiceStore.setUpdateTalentVoicesModalVisible(false);
                }}
                className="absolute right-5 top-5"
              >
                <FaTimes size={20} color="black"></FaTimes>
              </button>

              <div className="mt-14 flex justify-end gap-2">
                 <button  
                  className="relative w-40 h-10 bg-black text-white rounded-lg overflow-hidden"
                 onClick={() => 
                    {
                     this.handleAddBulkTags();
                    }
                }
                 >
                   Bulk Edit Tags
                </button>
                <button
                  disabled={loading}
                  onClick={() => {
                    this.state.files.map((file) => {
                      this.setState({ loading: true });
                      voiceStore
                        .updateTalentVoices(file)
                        .then(() => {
                          this.setState({ loading: false });
                        })
                        .catch((error) => {
                          this.setState({ loading: false });
                          console.error(error);
                        });
                      return file;
                    });
                  }}
                  className="relative w-40 h-10 bg-black text-white rounded-lg overflow-hidden"
                >
                  {loading ? (
                    <>
                      <div
                        className="absolute top-0 left-0 h-full bg-[#F89A1F] transition-all duration-300 ease-in-out"
                        style={{ width: `${voiceStore.progress}%` }}
                      ></div>
                      <span className="absolute inset-0 flex justify-center items-center font-semibold">
                        {voiceStore.progress}%
                      </span>
                    </>
                  ) : (
                    "Save Changes"
                  )}
                </button>
               
              </div>
            </div>
          </div>

          {/* Delete Modal */}
          {this.state.showDeleteModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
              <div className="bg-white rounded-lg p-5 w-[22rem]">
                <div className="flex flex-row justify-start items-center gap-x-2 mb-4">
                  <PiWarningCircleFill color="#F89A1F" />
                  <span className="font-normal text-sm">
                    Are you sure you want to delete this sample?
                  </span>
                </div>
                <div className="flex justify-end gap-4">
                  <button
                    onClick={this.toggleDeleteModal}
                    className="border border-[#D9D9D9] bg-white rounded-sm"
                  >
                    <span className="font-normal text-sm px-3">No</span>
                  </button>
                  <button
                    onClick={this.handleDelete}
                    className="border border-black bg-black rounded-sm"
                  >
                    <span className="font-normal text-sm px-3 text-white">
                      Yes
                    </span>
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }
  }
);

export default UpdateTalentVoicesModal;
